/**
 * Route content loader.
 *
 * Explains routing behavior, guards, and response semantics.
 */
import type { Route } from '../../types'
import { resolveRouteContentLocaleContext } from './route-content-loader/locale'
import { loadPageOrPreviewRouteContent } from './route-content-loader/page'
import { loadProductRouteContent } from './route-content-loader/product'
import type { LoadedRouteContentData } from './route-content-loader/types'

/**
 * Load route content data.
 *
 * Explains routing behavior, guards, and response semantics.
 */
export const loadRouteContentData = async (
  route: Route,
  signal: AbortSignal,
): Promise<LoadedRouteContentData> => {
  const localeContext = resolveRouteContentLocaleContext()

  if (route.mode === 'product') {
    return loadProductRouteContent({ route, signal, localeContext })
  }

  if (route.mode === 'page' || route.mode === 'preview') {
    return loadPageOrPreviewRouteContent({ route, signal, localeContext })
  }

  throw new Error('Errore caricamento pagina')
}
